import React from 'react';
import Layer from './Layer';
import Cols from './Cols';

function Cards({data, lg, md, lm, children, ...props}) {
  return (
    <Layer {...props}>
      <Cols {...{data, lg, md, lm}}>
        {children}
      </Cols>
    </Layer>
  );
}

export default Cards;


// WEBPACK FOOTER //
// ./src/components/Cards.js